import React from 'react'
import qs from 'qs'
import { URL, pushState } from './utils'
import { isNative } from '~/app/utils/typeguards'
import { getYaNative } from '@yanolja-org/ya-native'

type Props = React.ComponentProps<'a'>

// TODO: hybrid 분기도 지원하는건?
const Link = ({ href, ...rest }: Props) => {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()

    if (!href) return

    const isAbsolute = href.indexOf('://') > 0
    const yaNative = getYaNative()

    if (isAbsolute) {
      if (isNative(yaNative)) {
        const u = URL(href)

        yaNative.wv({
          method: 'get',
          url: href.replace(/\?.*$/, ''),
          params: qs.parse(u.search, { depth: 0 }) as any,
          layout: {
            modal: true,
            modalBottomNavi: false,
          },
        })
      } else {
        window.open(href)
      }
    } else {
      pushState(href)
    }
  }

  return <a href="#" onClick={handleClick} {...rest} />
}

export default Link
